// eslint-disable-next-line @typescript-eslint/naming-convention
export const Me = 'Me';

export const isMeTag = (str: string) => str === Me;
